import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Breadcrumb } from "react-bootstrap";
// import OrganizationTable from "../../components/backend/organization/OrganizationTable";
import SessionService from "../../service/SessionService";
import OrganizationService from "../../service/organization/OrganizationService";
import IndexTable from "../../components/common/IndexTable";

function Organizations({ loading, setLoading }) {
	const pageTitle = "Organizations | RTO Mobile";

	return (
		<>
			<Helmet>
				<title>{pageTitle}</title>
				<meta name="robots" content="noindex,nofollow"></meta>
				<meta property="og:title" content={pageTitle} />
				<meta name="twitter:title" content={pageTitle} />
			</Helmet>
			<div className="rto_form-sections">
				<div className="rto_content-div" style={{ maxWidth: "1600px" }}>
					<Breadcrumb
						listProps={{ className: "w-100 justify-content-end" }}
					>
						<Breadcrumb.Item
							linkAs={Link}
							linkProps={{ to: "/dashboard" }}
						>
							Dashboard
						</Breadcrumb.Item>
						<Breadcrumb.Item
							linkAs={Link}
							linkProps={{ to: "/settings" }}
						>
							Settings
						</Breadcrumb.Item>

						<Breadcrumb.Item active>Organizations</Breadcrumb.Item>
					</Breadcrumb>
					<div className="rto_title-div">
						<h1 className="rto_page-title">Organizations</h1>
					</div>
					<p className="text-center">
						{SessionService.canRtoAdmin() && (
							<Link
								className="btn btn-primary"
								to="/settings/organizations/create"
							>
								Create
							</Link>
						)}
					</p>
					<div
						className="card card-outline card-primary"
						style={{
							borderTop: "3px solid #00aaff",
							boxShadow:
								"0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
						}}
					>
						<div className="card-body">
							{/* <OrganizationTable
								loading={loading}
								setLoading={setLoading}
							/> */}
							<IndexTable
								model={"struct_organization"}
								loading={loading}
								setLoading={setLoading}
								service={OrganizationService}
								title="Organizations"
								actionButtons={
									SessionService.canRtoAdmin() && {
										updateLink: {
											path: "/settings/organizations",
										},
										// updateModal: {
										// 	enabled: true,
										// 	path: "/settings/organizations/update",
										// },
										// create: {
										// 	enabled: true,
										// 	path: "/settings/organizations/create",
										// },
									}
								}
								labels={[
									{
										id: "id",
										label: "ID",
									},
									{
										id: "struct_iso_name",
										label: "ISO",
										link: "/settings/isos",
									},
									{
										id: "struct_master_agent_name",
										label: "Master Agent",
										link: "/settings/master-agents",
									},
									{
										id: "struct_organization_name",
										label: "Organization",
										link: "/settings/organizations",
									},
									{
										id: "address_1",
										label: "Address 1",
									},
									{
										id: "address_2",
										label: "Address 2",
										initialDisplay: false,
									},
									{
										id: "city",
										label: "City",
									},
									{
										id: "state",
										label: "State",
									},
									{
										id: "zip",
										label: "Zip",
										initialDisplay: false,
									},
									{
										id: "phone",
										label: "Phone",
									},
									{
										id: "email_address",
										label: "Email",
									},
									{
										id: "status_name",
										label: "Status",
									},
									{
										id: "created",
										label: "Created At",
									},
									{
										id: "user_name",
										label: "Created By",
									},
								]}
								apiBase="/organization"
								successRedirectBase="settings/organizations"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Organizations;
